import "@hotwired/turbo-rails"
import "../controllers"
import "../lib/turboStreamActions"

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import { registerSvelte, globToComponents } from "../lib/registerSvelteNext.svelte"

const componentGlobs = import.meta.glob("../components/*.svelte", { eager: true })
const taskGlobs = import.meta.glob("../tasks/*.svelte", { eager: true })
const probateTasksGlobs = import.meta.glob("../tasks/Probate/*.svelte", { eager: true })

registerSvelte({
  ...globToComponents(componentGlobs),
  ...globToComponents(taskGlobs),
  ...globToComponents(probateTasksGlobs)
})

import "../behaviors/dialogAutoOpen"
import "../behaviors/preventDoubleSubmit"

import "../lib/posthog"
